/* assets/two-cols-init.js */
(function(){
  // Registrar módulo
  window.__SectionRegistry['two-cols'] = function(wrapper){
    const { gsap, ScrollTrigger } = window;
    if (!(gsap && ScrollTrigger)) {
      console.warn('[two-cols] GSAP/ScrollTrigger no disponibles (aún).');
      return; // no cleanup necesario
    }
    gsap.registerPlugin(ScrollTrigger);

    // Opcional: markers globales si activas debug (en consola: localStorage.GSAP_DEBUG='1')
    const DEBUG = !!localStorage.getItem('GSAP_DEBUG');
    if (DEBUG && !document.getElementById('gsap-markers-zfix')) {
      const s = document.createElement('style');
      s.id = 'gsap-markers-zfix';
      s.textContent = `
        .gsap-marker-start,.gsap-marker-end,
        .gsap-marker-scroller-start,.gsap-marker-scroller-end { z-index:2147483647 !important; }
      `;
      document.head.appendChild(s);
    }

            const root = wrapper.querySelector('[data-two-cols-root]') || wrapper;

      // Targets (no cortamos ejecución si falta alguno)
      const imgLeft  = root.querySelector('.col__left .image');
      const imgRight = root.querySelector('.col__right .image');
      const vidRight = root.querySelector('.col__right .media');
      const itemsLeft  = root.querySelectorAll('.col__left .item');
      const itemsRight  = root.querySelectorAll('.col__right .item');
      const bgImg  = root.querySelectorAll('.banner__bg');

      // Animas UNO a la derecha: prioriza video; si no hay, usa imagen
      const rightPreferred = vidRight || imgRight;

      const ctx = gsap.context(() => {
        ScrollTrigger.defaults({ scroller: document.documentElement });

        // helpers
        const commonST = (triggerEl) => ({
          trigger: triggerEl,
          start: 'top 85%',
          end: 'bottom 85%',
          scrub: true,
          invalidateOnRefresh: true,
          // clear props al salir para no dejar transform “pegado”
          onLeave: () => gsap.set(triggerEl, { clearProps: 'transform,opacity' }),
          //onLeaveBack: () => gsap.set(triggerEl, { clearProps: 'transform,opacity' }),
        });

        if (imgLeft) {
          gsap.fromTo(
            imgLeft,
            { xPercent: -30, opacity: 0.001 },
            { xPercent: 0, opacity: 1, ease: 'power3.out', overwrite: false, scrollTrigger: commonST(imgLeft) }
          );
        }

        if (rightPreferred) {
          gsap.from(
            rightPreferred,
            { xPercent: 30, opacity: 0.001, ease: 'power3.out', overwrite: false, scrollTrigger: commonST(rightPreferred) }
          );
        }

        if (itemsLeft) {
          gsap.from(itemsLeft, {
            opacity: 0,
            y: 40,
            ease: 'power3.out',
            stagger: 0.15,
            scrollTrigger: {
              trigger: itemsLeft,
              start: 'top 85%',
              end: 'bottom 70%',
              scrub: true,
            }
          });
        }

        if (itemsRight) {
          gsap.from(itemsRight, {
            opacity: 0,
            y: 40,
            ease: 'power3.out',
            stagger: 0.15,
            scrollTrigger: {
              trigger: itemsRight,
              start: 'top 85%',
              end: 'bottom 70%',
              scrub: true,
              
            }
          });
        }
        

        // Refresca tras montar
      requestAnimationFrame(() => ScrollTrigger.refresh());
    }, root);

    // Devuelve cleanup para que sections-boot.js lo ejecute al desmontar
    return () => { try { ctx.revert(); } catch(_){} };
  };

  // Si el core ya cargó, libera la cola (por si algunas secciones llegaron antes que este archivo)
  window.__flushSectionQueue && window.__flushSectionQueue('two-cols');
})();